module.exports = __webpack_public_path__ + "static/media/perk-solopreneur-3.a527c664.jpg";